export default function formatStrategyBenchmarkRateOfReturn(rate, locale = "en") {
  const percent = rate * 100;
  const sign = percent >= 0 ? "+" : "-";
  const absoluteValue = Math.abs(percent).toFixed(2);
  const localizedValue =
    locale === "pl" ? absoluteValue.replace(".", ",") : absoluteValue;

  return `${sign}${localizedValue}%`;
}
